import { NotifyHelper } from "../../helpers/toast";
import { eConnectionActionTypeDefine } from "../action-types/IConnectionActionTypes";
import { generateActionForKey, generateActions } from "./generateActions";

export const connectionActions = {
    ...generateActions(eConnectionActionTypeDefine, "CONNECTION"),
    ...generateActionForKey(eConnectionActionTypeDefine, "CONNECTION",
        "GENERATE_ERROR",
        (data) => {
            NotifyHelper.Error(data.data)
        }
    ),

}